import { Stack } from '@mui/material'
import { DisplayValueModeToggle } from './DisplayValueModeToggle'
import { DisplayProductsModeToggle } from './DisplayProductsModeToggle'
import { TableSort } from './TableSort'
import { SpeciesSelector } from './SpeciesSelector'
import { StyledBox } from './PlanTableToolbar.styles.ts'
import ImportFromInventory from './ImportFromInventory'

const PlanTableToolbar = () => {
  return (
    <StyledBox>
      <DisplayValueModeToggle />
      <DisplayProductsModeToggle />
      <TableSort />

      <Stack display="flex" flexDirection="row" gap="8px" marginLeft="auto">
        <SpeciesSelector />
        <ImportFromInventory />
      </Stack>
    </StyledBox>
  )
}

export default PlanTableToolbar
